import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { EventTypeData } from "../../../_models/event-type-data";

@Component({
  selector: "events-type-management-row-header",
  templateUrl: "events-type-management-row-header.component.html",
  styleUrls: [
    "../events-type-row/events-type-management-row.component.scss",
    "./events-type-management-row-header.component.scss",
  ],
})
export class EventsTypeManagementRowHeaderComponent {
  @Input("circleNames") public circleNames: string[] = [];
  public eventType: Record<keyof EventTypeData, string> = {
    id: "",
    name: "שם סוג ארוע",
    isVisible: "פעיל",
    isMultiday: "כולל לינה",
    defaultIndex: "אינדקס ברירת מחדל",
    indexes: "",
  };
  public trimText(text: string) {
    return text;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/event-type-management/events-type-row-header/events-type-management-row-header.component.ts